// extracted by mini-css-extract-plugin
export default {"search":"search_search__dD1jP"};